<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 职位 -->
        <div class="job column">
            <!-- 职位顶部 -->
            <div class="job_top">
                <div class="job_top_m row">
                    <!-- <img src="@/assets/images/zhiweidingbu.png" alt="" style="width: 100%;"> -->
                    <div class="job_top_m_l column">
                        <!-- <div class="job_top_m_l_status">招聘中</div> -->
                        <div class="job_top_m_l_zhiwei row">
                            <div class="job_top_m_l_zhiwei_name">{{ dataInfo.name }}</div>
                            <div class="job_top_m_l_zhiwei_xinzi" v-if="dataInfo.salaryType == 0">
                                {{ dataInfo.salaryLowest }}-{{ dataInfo.salaryHighest }}k·{{ dataInfo.salaryCnt }}薪
                            </div>
                            <div class="job_top_m_l_zhiwei_xinzi" v-if="dataInfo.salaryType == 1">
                                {{ dataInfo.salaryLowest }}-{{ dataInfo.salaryHighest }}k 年薪
                            </div>
                            <div class="job_top_m_l_zhiwei_xinzi" v-if="dataInfo.salaryType == 2">面议</div>
                            <div class="job_top_m_l_zhiwei_xinzi" v-if="dataInfo.salaryType == 3">
                                {{ dataInfo.salaryLowest }}-{{ dataInfo.salaryHighest }}元 时薪
                            </div>
                            <div class="job_top_m_l_zhiwei_xinzi" v-if="dataInfo.salaryType == 4">
                                {{ dataInfo.salaryLowest }}-{{ dataInfo.salaryHighest }}元 日薪
                            </div>
                        </div>
                        <div class="job_top_m_l_xinxi row">
                            <div class="job_top_m_l_xinxi_m row" v-if="dataInfo.workCities">
                                <i class="el-icon-location"></i>
                                <span v-for="(item, index) in dataInfo.workCities" :key="index">{{ item }}&nbsp;</span>
                            </div>
                            <div class="job_top_m_l_xinxi_m row" v-if="dataInfo.workYearText">
                                <i class="el-icon-s-cooperation"></i>
                                <span>{{ dataInfo.workYearText }}</span>
                            </div>
                            <div class="job_top_m_l_xinxi_m row" v-if="dataInfo.educationText">
                                <i class="el-icon-s-home"></i>
                                <span>{{ dataInfo.educationText }}</span>
                            </div>
                        </div>
                        <div class="job_top_m_l_anniu row" v-if="zhuangtai">
                            <div class="job_top_m_l_anniu_ganxingqu" @click="clickganxingqu(dataInfo)">
                                <i class="el-icon-star-off"></i>
                                <i class="el-icon-star-on"></i>
                                <span v-if="dataInfo.like == 1">取消感兴趣</span>
                                <span v-if="dataInfo.like == 0">感兴趣</span>
                            </div>
                            <div class="job_top_m_l_anniu_lijigoutong" @click="lijigoutong(dataInfo)">立即沟通</div>
                        </div>
                        <div class="job_top_m_l_anniu row" v-else>
                            <!-- <div class="job_top_m_l_anniu_lijigoutong2" @click="chakangengduoyouxuanzhiwei">查看更多优选职位</div> -->
                            <div class="job_top_m_l_anniu_ganxingqu" @click="clickPopupLogin">
                                <i class="el-icon-star-off"></i>
                                <i class="el-icon-star-on"></i>
                                <span v-if="dataInfo.like == 1">取消感兴趣</span>
                                <span v-if="dataInfo.like == 0">感兴趣</span>
                            </div>
                            <div class="job_top_m_l_anniu_lijigoutong" @click="clickPopupLogin">立即沟通</div>
                        </div>
                    </div>
                    <div class="job_top_m_r column">
                        <div class="job_top_m_r_top row">
                            <div class="job_top_m_r_top_tabs" v-for="(item, index) in dataInfo.highlightsArr" :key="index">
                                <span>{{ item }}</span>
                            </div>
                            <div class="job_top_m_r_top_more">
                                <div class="job_top_m_r_top_more_dian">...</div>
                                <div class="job_top_m_r_top_more_tabs">
                                    <span v-for="(item, index) in dataInfo.highlightsArr" :key="index">{{ item }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="job_top_m_r_bottom row">
                            <!-- <div class="job_top_m_r_bottom_m row">
                                <i class="el-icon-tickets job_top_m_r_bottom_m_i"></i>
                                <div class="job_top_m_r_bottom_m_text">完善在线简历</div>
                            </div>
                            <div class="job_top_m_r_bottom_m row">
                                <i class="el-icon-paperclip job_top_m_r_bottom_m_i"></i>
                                <div class="job_top_m_r_bottom_m_text">新增附件简历</div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 职位顶部 end -->
            <!-- 职位内容 -->
            <div class="job_main row">
                <div class="job_main_l column">
                    <div class="job_main_l_zhiweimiaoshu column">
                        <!-- <img src="@/assets/images/zhiweineirong.png" alt="" style="width: 100%;"> -->
                        <div class="job_main_l_zhiweimiaoshu_zhiweimiaoshu column">
                            <div class="job_main_l_zhiweimiaoshu_zhiweimiaoshu_title">职位描述</div>
                            <div class="row job_main_l_zhiweimiaoshu_zhiweimiaoshu_tabs">
                                <span v-for="(item, index) in dataInfo.jobTagsArr" :key="index" v-if="item">{{ item
                                }}</span>
                            </div>
                            <div class="job_main_l_zhiweimiaoshu_zhiweimiaoshu_main">{{ dataInfo.description }}
                                <br>
                                <br>
                                <span>其它：</span>
                                <br>{{ dataInfo.requirement }}
                                <!-- 1、从事C/C++软件开发和软件设计等工作;
                                <br />2、负责产品软件开发,完成与工作相关的文档编写;
                                <br />3、参与应用设计与方案讨论。
                                <br />岗位要求:
                                <br />1.熟练编写软件页面和底层逻辑;
                                <br />2.熟悉Unix/Linux操作系统原理,了解Unix/Linux平台软件开发方式(熟练使用GCC、VI),能熟练使用shell;
                                <br />3.精通各种底层协议,网络协议优先,精通linux下C程序开发优先,有良好的C/C++编程技能;
                                <br />4.熟练掌握Unix/Linux下多线程及socket编程;
                                <br />5.能参与系统中组件或子模块的详细设计、实现及代码优化;
                                <br />6.有上进心能主动积极地面对工作,团队沟通能力佳,有团队精神
                                <br />其它:
                                <br />1.熟悉TCP/IP/UDP等协议开发经验者优先;
                                <br />2.有网络设备软件开发经验者优先
                                <br />3.有LUA语言开发经验者优先
                                <br />4.有C#语言开发经验者优先 -->
                            </div>
                        </div>
                    </div>
                    <div class="job_main_l_guwen row">
                        <img :src="dataInfo.publisherAvatar" class="job_main_l_guwen_img">
                        <div class="job_main_l_guwen_r column">
                            <div class="job_main_l_guwen_r_top">{{ dataInfo.publisherName }}</div>
                            <div class="job_main_l_guwen_r_bottom">
                                {{ dataInfo.companyName }}
                                <span v-if="dataInfo.publisherPosition">&nbsp;·&nbsp;</span>
                                {{ dataInfo.publisherPosition }}
                            </div>
                        </div>
                    </div>
                    <!-- <div class="job_main_l_gongsijieshao">
                        <img src="@/assets/images/zhiweigongsijieshao.png" alt="" style="width: 100%;">
                    </div> -->
                    <!-- <div class="job_main_l_kanguogaizhiwei">
                        <img src="@/assets/images/zhiweikanguolehaikan.png" alt="" style="width: 100%;">
                    </div> -->
                    <!-- <div class="job_main_l_jingxuan">
                        <img src="@/assets/images/zhiweijingxuan.png" alt="" style="width: 100%;">
                    </div> -->
                    <!-- <div class="job_main_l_chengshizhaopin">
                        <img src="@/assets/images/chengshizhaopin.png" alt="" style="width: 100%;">
                    </div> -->
                </div>
                <div class="job_main_r column">
                    <div class="job_main_r_gongsi column">
                        <div class="job_main_r_gongsi_top">公司基本信息</div>
                        <div class="job_main_r_gongsi_main column">
                            <div class="job_main_r_gongsi_main_top row">
                                <img src="@/assets/images/gongsi.png" class="job_main_r_gongsi_main_top_img">
                                <div class="job_main_r_gongsi_main_top_title">{{ dataInfo.companyName }}</div>
                            </div>
                            <div class="job_main_r_gongsi_main_text column">
                                <!-- <div class="job_main_r_gongsi_main_text_m row">
                                    <i class="el-icon-s-finance"></i>
                                    不需要融资
                                </div> -->
                                <div class="job_main_r_gongsi_main_text_m row" v-if="dataInfo.companyScaleText">
                                    <i class="el-icon-user-solid"></i>
                                    {{ dataInfo.companyScaleText }}人
                                </div>
                                <div class="job_main_r_gongsi_main_text_m row" v-if="dataInfo.companyTypeText">
                                    <i class="el-icon-s-flag"></i>
                                    {{ dataInfo.companyTypeText }}
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- <div class="job_main_r_xiangsizhiwei">
                        <img src="@/assets/images/zhiweixiangsizhiwei.png" alt="" style="width: 100%;">
                    </div> -->
                    <div class="job_main_r_guanggao" v-for="(item, index) in adList" :key="index">
                        <a :href="item.link" target="_blank">
                            <img :src="item.url" alt="" style="width: 100%;">
                        </a>
                    </div>
                    <!-- <div class="job_main_r_guanggao">
                        <img src="@/assets/images/guanggao1.png" alt="" style="width: 100%;">
                    </div>
                    <div class="job_main_r_guanggao">
                        <img src="@/assets/images/guanggao2.png" alt="" style="width: 100%;">
                    </div>
                    <div class="job_main_r_guanggao">
                        <img src="@/assets/images/guanggao3.jpg" alt="" style="width: 100%;">
                    </div> -->
                </div>
            </div>
            <!-- 职位内容 end -->
        </div>
        <!-- 底部 -->
        <Footer></Footer>
        <!-- 其他城市弹窗 -->
        <PopupLogin v-if="dialogPopupLoginVisible" @clickPopupLogin="clickDialogPopupLogin"></PopupLogin>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'
import PopupLogin from '@/components/PopupLogin.vue'

export default {
    name: 'LaJobDetails',
    components: { NavTop, Footer, PopupLogin },
    data() {
        return {
            id: 0,
            dataInfo: {},
            zhuangtai: false,
            adList: [],
            userId: 0,
            dialogPopupLoginVisible: false,
        }
    },
    mounted() {
        // 获取广告
        this.getAdByType();
    },
    activated() {
        // 获取用户信息
        this.getUserInfo();
        if (this.$route.params.id) {
            this.id = this.$route.params.id;
            this.getJobId();
        }
        if (localStorage.getItem('Authorization')) {
            this.zhuangtai = true;
        } else {
            this.zhuangtai = false;
        }
    },
    methods: {
        // 获取用户信息
        async getUserInfo() {
            try {
                let res = await this.$API.getUserInfoApi();
                console.log('获取用户信息-->', res);
                if (res.code == 0) {
                    this.userId = res.data.id;
                }
            } catch (error) {
                console.log('获取用户信息error-->', error);
            }
        },
        // 获取广告
        async getAdByType() {
            let res = await this.$API.getAdByTypeApi(2);
            console.log('获取广告-->', res);
            if (res.code == 0) {
                this.adList = res.data;
            }
        },
        // 获取职位详情
        async getJobId() {
            let res = await this.$API.getJobIdApi(this.id);
            console.log('获取职位详情-->', res);
            this.dataInfo = res.data;
            this.dataInfo.jobTagsArr = res.data.jobTags.split('|');
            this.dataInfo.highlightsArr = res.data.highlights.split('|');
            // this.dataInfo.jobTagsArr = res.data.jobTags;
            // this.dataInfo.highlightsArr = res.data.highlights;
        },
        // 感兴趣
        clickganxingqu(dataInfo) {
            if (dataInfo.like == 0) {
                this.postJobLikeId(dataInfo.id);
            }
            if (dataInfo.like == 1) {
                this.delJobLikeId(dataInfo.id);
            }
        },
        // 标记职位为感兴趣
        async postJobLikeId(id) {
            try {
                let res = await this.$API.postJobLikeIdApi(id);
                console.log('标记职位为感兴趣-->', res);
                if (res.code == 0) {
                    this.dataInfo.like = 1;
                } else {
                    this.$message.error(res.message);
                }
            } catch (error) {
                this.$message.error(res.message);
            }
        },
        // 标记职位为不感兴趣
        async delJobLikeId(id) {
            try {
                let res = await this.$API.delJobLikeIdApi(id);
                console.log('标记职位为不感兴趣-->', res);
                if (res.code == 0) {
                    this.dataInfo.like = 0;
                } else {
                    this.$message.error(res.message);
                }
            } catch (error) {
                this.$message.error(res.message);
            }
        },
        // 立即沟通
        lijigoutong(dataInfo) {
            console.log('立即沟通-->', dataInfo);
            this.postZyspChatSession(dataInfo);
            // this.$router.push('/chat');

        },
        // 创建会话
        async postZyspChatSession(dataInfo) {
            let res = await this.$API.postZyspChatSessionApi(
                dataInfo.id, // 职位id
            );
            console.log('创建会话-->', res);
            if (res.code == 0) {
                this.$router.push('/chat');
            }
        },
        // 弹窗登录
        clickPopupLogin() {
            this.dialogPopupLoginVisible = true;
            console.log('点击弹窗登录-->', this.dialogPopupLoginVisible);
        },
        // 获取弹窗登录
        clickDialogPopupLogin(val) {
            console.log('获取弹窗登录-->', val);
            this.dialogPopupLoginVisible = val.state;
            if (val.reload) {
                location.reload();
            }
        },


        // 查看更多优选职位
        chakangengduoyouxuanzhiwei() {
            this.$router.push('/search');
        }
    }

}
</script>

<style scoped>
.job {
    width: 100%;
    height: auto;
}

.job_top {
    width: 100%;
    height: auto;
    background: linear-gradient(90deg, #3b526a 0, #345a6d 100%);
    padding: 20px 0 30px;
}

.job_top_m {
    width: 1200px;
    height: auto;
    margin: auto;
    justify-content: space-between;
}

.job_top_m_l {
    width: 680px;
}

.job_top_m_l_status {
    color: #fff;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    margin-bottom: 10px;
}

.job_top_m_l_zhiwei {
    padding: 0;
    line-height: 41px;
    height: 41px;
    font-size: 32px;
    color: #fff;
    font-weight: 400;
}

.job_top_m_l_zhiwei_name {
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    line-height: 40px;
    margin-right: 30px;
    margin-top: 1px;
    max-width: 360px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.job_top_m_l_zhiwei_xinzi {
    font-size: 34px;
    color: #f26d49;
    line-height: 41px;
    height: auto;
    font-weight: 400;
    top: -2px;
}

.job_top_m_l_xinxi {
    margin-top: 16px;
    margin-bottom: 0;
    color: #fff;
}

.job_top_m_l_xinxi_m {
    font-size: 14px;
    color: #fff;
    line-height: 20px;
    height: 20px;
    margin-right: 20px;
    align-items: center;
}

.job_top_m_l_xinxi_m>i {
    margin-right: 5px;
}

.job_top_m_l_anniu {
    margin-top: 20px;
}

.job_top_m_l_anniu_ganxingqu {
    color: #00b277;
    border: 1px solid #00b277;
    width: 150px;
    border-radius: 10px;
    font-size: 18px;
    line-height: 43px;
    height: 45px;
    transition: all .2s linear;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
}

.job_top_m_l_anniu_ganxingqu:hover {
    color: #00b277;
    background: #00b2771a;
    border: 1px solid #00b277;
}

.el-icon-star-on {
    display: none;
}

.job_top_m_l_anniu_ganxingqu:hover>.el-icon-star-off {
    display: none;
}

.job_top_m_l_anniu_ganxingqu:hover>.el-icon-star-on {
    display: inline-block;
    font-size: 22px;
}

.job_top_m_l_anniu_ganxingqu>i {
    margin-right: 5px;
    font-size: 22px;
}

.job_top_m_l_anniu_lijigoutong {
    margin-left: 16px;
    background: #00b277;
    color: #fff;
    border: 1px solid #00b277;
    width: 150px;
    border-radius: 10px;
    font-size: 18px;
    line-height: 43px;
    height: 45px;
    transition: all .2s linear;
    box-sizing: border-box;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
}

.job_top_m_l_anniu_lijigoutong2 {
    background: #00b277;
    color: #fff;
    border: 1px solid #00b277;
    border-radius: 10px;
    font-size: 18px;
    line-height: 43px;
    height: 45px;
    transition: all .2s linear;
    box-sizing: border-box;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    padding: 0 20px;
}

.job_top_m_l_anniu_lijigoutong:hover {
    background: #00b277;
    border: 1px solid #00b277;
}

.job_top_m_r {
    justify-content: space-between;
}

.job_top_m_r_top {
    margin-top: 36px;
    width: 480px;
    align-items: center;
    justify-content: flex-end;
}

.job_top_m_r_top_tabs {
    padding-top: 8px;
    height: 27px;
    overflow: hidden;
    display: inline-block;
    align-items: center;
    text-align: right;
}

.job_top_m_r_top_tabs>span {
    height: 28px;
    line-height: 28px;
    background: rgba(255, 255, 255, .05);
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
    padding: 0 8px;
    border: none;
    margin-right: 8px;
    margin-bottom: 8px;
    display: inline-block;
}

.job_top_m_r_top_more {
    height: 26px;
    line-height: 21px;
    background: rgba(255, 255, 255, .05);
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
    padding: 0 8px;
    border: none;
    margin-top: 8px;
    font-weight: 500;
    letter-spacing: 2px;
    text-align: center;
    border: 1px solid transparent;
    cursor: pointer;
    position: relative;
}

.job_top_m_r_top_more:hover {
    background: #00b2771a;
    border: 1px solid #00b277;
    color: #00b277;
}

.job_top_m_r_top_more_dian {}

.job_top_m_r_top_more:hover .job_top_m_r_top_more_tabs {
    display: block;
}

.job_top_m_r_top_more_tabs {
    width: 500px;
    height: auto;
    background: #fff;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .08);
    border-radius: 8px;
    padding: 14px 12px;
    top: 36px;
    right: 0;
    display: none;
    position: absolute;
    z-index: 100;
}

.job_top_m_r_top_more_tabs>span {
    background: #00b2771a;
    color: #00b277;
    margin: 6px 8px;
    height: 28px;
    line-height: 28px;
    border-radius: 4px;
    font-size: 14px;
    /* white-space: nowrap; */
    padding: 0 8px;
    float: left;
    border: none;
}

.job_top_m_r_bottom {
    align-items: center;
    justify-content: flex-end;
}

.job_top_m_r_bottom_m {
    color: #00b277;
    margin-left: 20px;
    align-items: center;
    cursor: pointer;
}

.job_top_m_r_bottom_m:hover {
    color: #00b277;
}

.job_top_m_r_bottom_m_i {
    font-size: 16px;
    line-height: 22px;
    margin-right: 10px;
}

.job_top_m_r_bottom_m_text {
    font-size: 16px;
    line-height: 22px;
}

.job_main {
    width: 1200px;
    height: auto;
    margin: 15px auto 0;
    justify-content: space-between;
}

.job_main_l {
    width: 840px;
    height: auto;
    padding: 20px 30px;
    background: #fff;
    border-radius: 10px;
}

.job_main_l_zhiweimiaoshu {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
}

.job_main_l_zhiweimiaoshu_zhiweimiaoshu {}

.job_main_l_zhiweimiaoshu_zhiweimiaoshu_title {
    font-size: 18px;
    font-weight: 600;
    color: #222;
    line-height: 25px;
    margin-bottom: 10px;
}

.job_main_l_zhiweimiaoshu_zhiweimiaoshu_tabs {
    width: 100%;
}

.job_main_l_zhiweimiaoshu_zhiweimiaoshu_tabs>span {
    margin-top: 8px;
    margin-right: 8px;
    font-size: 14px;
    color: #666;
    line-height: 20px;
    float: left;
    padding: 4px 12px;
    white-space: nowrap;
    background: #f8f8f8;
    border-radius: 4px;
}

.job_main_l_zhiweimiaoshu_zhiweimiaoshu_main {
    white-space: pre-wrap;
    word-break: break-all;
    margin-top: 20px;
    margin-bottom: 20px;
    line-height: 28px;
    color: #333;
    font-size: 15px;
    text-align: justify;
    letter-spacing: 0;
}

.job_main_l_guwen {
    border-top: 1px solid #ededed;
    padding-top: 20px;
}

.job_main_l_guwen_img {
    width: 56px;
    height: 56px;
    display: block;
    border-radius: 100%;
    margin-right: 0;
    margin-right: 20px;
    border: 1px px solid #f6fdfd;
    border-radius: 100%;
}

.job_main_l_guwen_r {}

.job_main_l_guwen_r_top {
    font-size: 20px;
    font-weight: 500;
    color: #222;
    line-height: 28px;
    display: flex;
    align-items: center;
}

.job_main_l_guwen_r_bottom {
    font-size: 15px;
    color: #666;
    line-height: 21px;
    margin-top: 8px;
    display: flex;
    align-items: center;
}

.job_main_l_gongsijieshao {
    width: 840px;
    height: auto;
    padding: 20px 30px;
    background: #fff;
    border-radius: 10px;
    margin-top: 15px;
}

.job_main_l_kanguogaizhiwei {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 15px;
}

.job_main_l_jingxuan {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 15px;
}

.job_main_l_chengshizhaopin {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 15px;
}

.job_main_r {
    width: 280px;
    height: auto;
}

.job_main_r_gongsi {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    padding-bottom: 20px;
}

.job_main_r_gongsi_top {
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
    padding: 12px 24px;
    background: linear-gradient(90deg, #f5fcfc 0, #fcfbfa 100%);
    margin-bottom: 0;
    border-radius: 10px 10px 0 0;
}

.job_main_r_gongsi_main {}

.job_main_r_gongsi_main_top {
    align-items: center;
    padding: 16px 24px;
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 500;
    color: #222;
    line-height: 22px;
}

.job_main_r_gongsi_main_top_img {
    width: 48px;
    height: 48px;
    margin-right: 16px;
    border: 1px solid #f3f5fb;
    border-radius: 8px;
}

.job_main_r_gongsi_main_top_title {
    color: #414a60;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
}

.job_main_r_gongsi_main_text {}

.job_main_r_gongsi_main_text_m {
    padding: 0 24px;
    align-items: center;
    font-size: 15px;
    color: #333;
    line-height: 21px;
    margin-bottom: 8px;
}

.job_main_r_gongsi_main_text_m>i {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    color: #bfbfbf;
}

.job_main_r_xiangsizhiwei {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 20px;
}

.job_main_r_guanggao {
    width: 100%;
    height: auto;
    background: #fff;
    border-radius: 10px;
    margin-top: 20px;
}

.job_main_r_guanggao img {
    border-radius: 10px;
}
</style>
